import React, { useEffect, useRef, useCallback } from 'react';
import { appHandler } from '@blaze-cms/core-ui';
import { useRouter } from 'next/router';
import { checkIfLoggedIn } from '@blaze-cms/core-auth-ui';
import { RouteContextProvider } from './RouteContext';

const RouteContextWrapper = ({ children }) => {
  const app = appHandler.getApp();
  const router = useRouter();
  const previousUrl = useRef('');
  const markedUrl = useRef('');
  const nextRedirect = useRef('');

  const handleLoginAccountRedirects = useCallback(
    url => {
      // Redirect to my-account if logged in and trying to access login page
      const { isLoggedIn } = checkIfLoggedIn();
      if (isLoggedIn && (url === '/login' || url.startsWith('/set-password?'))) {
        router.push('/Resolver', '/my-account');
        return true;
      }
      if (!isLoggedIn && url === '/my-account') {
        router.push('/Resolver', '/login');
        return true;
      }

      return false;
    },
    [router]
  );

  useEffect(() => {
    handleLoginAccountRedirects(router.asPath);

    const storePreviousUrl = url => {
      previousUrl.current = router.asPath;
    };

    const handleUrlChange = urlToCheck => {
      if (nextRedirect.current) {
        if (urlToCheck === nextRedirect.current) {
          nextRedirect.current = '';
          return;
        }
        router.push('/Resolver', nextRedirect.current);
        markedUrl.current = '';
        return;
      }

      if (urlToCheck === '/login') {
        markedUrl.current = previousUrl.current;
      } else if (urlToCheck === '/subscribe' && !markedUrl.current) {
        markedUrl.current = previousUrl.current;
      }

      handleLoginAccountRedirects(urlToCheck);
    };

    const handleLogin = () => {
      if (router.asPath === '/payment' || router.asPath === '/subscribe') return; // don't redirect if user is on payment page, as they will be redirected after payment

      if (markedUrl.current && markedUrl.current !== router.asPath) {
        // do redirect in routeChangeComplete event
        nextRedirect.current = markedUrl.current;
      }
    };

    app.events.on('package:core-auth-ui:login', handleLogin);
    router.events.on('routeChangeStart', storePreviousUrl);
    router.events.on('routeChangeComplete', handleUrlChange);

    return () => {
      app.events.off('package:core-auth-ui:login', handleLogin);
      router.events.off('routeChangeStart', storePreviousUrl);
      router.events.off('routeChangeComplete', handleUrlChange);
    };
  }, [app.events, handleLoginAccountRedirects, previousUrl, router]);

  return <RouteContextProvider>{children}</RouteContextProvider>;
};

export default RouteContextWrapper;
